<template>
  <section class="form-details" aria-labelledby="form-details-title">
    <div>
      <h2 id="form-details-title" class="form-details-title">Form details</h2>
      <dl class="form-details-list">
        <dt>Fields</dt>
        <dd>
          <ul class="form-details-fields">
            <li v-for="(field, index) in form.elements || []" :key="index">{{ field }}</li>
          </ul>
        </dd>
        <dt>Name or identifier</dt>
        <dd>{{ form.name || 'not set' }}</dd>
        <dt>Page</dt>
        <dd class="form-details-page">{{ page }}</dd>
      </dl>
    </div>
    <button type="button" class="ex-btn ex-btn--secondary ex-btn--small no-print" @click="$emit('download')">
      <ph-icon name="download-simple" :size="16" />
      <span class="ex-btn__label" data-label="Download as CSV">Download as CSV</span>
    </button>
  </section>
</template>

<script>
import PhIcon from './PhIcon.vue'

export default {
  name: 'FormDetails',
  components: { PhIcon },
  props: {
    form: { type: Object, required: true },
    uri: { type: String, required: true }
  },
  computed: {
    page () {
      return this.uri.replace(/^https?:\/\/(www\.)?/i, '')
    }
  }
}
</script>

<style scoped>
.form-details {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  align-items: center;
  padding: 28px 32px;
  border: 1px solid var(--ex-color-hairline);
  border-radius: var(--ex-radius-panel);
  background: var(--ex-color-white);
}

.form-details-title {
  font-size: 20px;
  letter-spacing: -0.02em;
}

.form-details-list {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px 16px;
  margin: 14px 0 0;
  font-size: 14px;
}

.form-details-list dt {
  color: var(--ex-color-neutral-500);
}

.form-details-list dd {
  margin: 0;
  min-width: 0;
}

.form-details-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.form-details-fields li {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border-radius: var(--ex-radius-pill);
  background: var(--ex-color-surface-blue);
  font-size: 13px;
}

.form-details-page {
  overflow-wrap: anywhere;
}

@media (max-width: 760px) {
  .form-details {
    grid-template-columns: 1fr;
    padding: 24px 20px;
  }

  .form-details-list {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .form-details-list dd + dt {
    margin-top: 8px;
  }
}
</style>
